import React from "react";
import Button from "../components/button/Button.tsx";
import Header from "../layout/Header.tsx";
import { NavLink } from "react-router-dom";
import Footer from "../layout/Footer.tsx";

const Page404 = () => {
  return (
    <>
      <div className="max-w-[1440px] mx-auto bg-white">
        <Header className={"bg-white"} />
        <div className="bg-white items-center justify-center w-full flex">
          <div className="w-[90%] max-w-2xl text-center items-center justify-center py-[18%] lg:py-[8%] flex flex-col gap-6">
            <img
              className="w-[70%] lg:w-[50%]"
              src="/assets/images/404page.png"
              alt="404 page"
            />
            <h2 className="font-display text-2xl lg:text-3xl font-semibold tracking-tight text-lightBlack">
              Something went wrong
            </h2>
            <p className="text-gray-500 text-base leading-relaxed max-w-md">
              Sorry, we can't find the page you're looking for. It may have been moved or removed.
            </p>
            <div className="pt-2">
              <NavLink to={"/"}>
                <Button children={"Go Back Home"} className="!w-auto !px-8" disabled={false} />
              </NavLink>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Page404;
